const clearDocumentSelectionStyles = async (context) => {
  try {
    const selection = context.document.getSelection();
    const { paragraphs } = selection;

    selection.load("text");
    paragraphs.load("items/text");
    await context.sync();

    const selectionText = (selection.text || "").trim();

    paragraphs.items
      .filter((paragraph) => {
        const paragraphText = (paragraph.text || "").trim();
        return (
          paragraphText === "" ||
          (selectionText !== "" && selectionText.includes(paragraphText))
        );
      })
      .forEach((paragraph) => {
        paragraph.styleBuiltIn = Word.BuiltInStyleName.normal;
        paragraph.font.bold = false;
        paragraph.font.italic = false;
        paragraph.font.underline = Word.UnderlineType.none;
      });

    await context.sync();
  } catch {
    // A document that refuses the style reset should still receive the content
  }
};

export default clearDocumentSelectionStyles;
